import { Link, Outlet, useNavigate } from "react-router-dom";
import { Dialog, DialogActions, DialogContent, DialogTitle } from '@mui/material'
import { useFormik } from 'formik';
import React from 'react'
import { useEffect } from 'react';
import { useState } from 'react';
import { loginValidationSchema } from './Validations/ValidationSchemas';
import TextInput from '../components/input/TextInput';
import SubmitButton from '../components/buttons/SubmitButton';
import { loginHttp } from '../services/AccountService';

const loginSchema = {
    userName:"",
    password:""
}

const CATEGORY = "category";
const SUBCATEGORY = "subcategory";
const PRODUCT = "product";

const ADD = "add";
const LIST = "list";
const UPDATE = "update";

function AdminPanelLayout() {
  //
  
  const [open, setOpen] = useState(true)
  const navigateTo = useNavigate();

  const handleSubmit = (values) => {
      loginHttp(values).then((resp)=>{
          localStorage.setItem("admin",resp.data)
          if(resp.data)
              navigateTo("/admin-panel");
      })
  }

  const formik = useFormik({
      initialValues: loginSchema,
      validationSchema: loginValidationSchema,
      validateOnChange: false,
      validateOnMount: false,
      validateOnBlur: false,
      onSubmit: (values) => handleSubmit(values),
  });
  
  const toBoolean = (input) => {
  if (input === 'true') {
      return true;
  }
  return false;
  }

  useEffect(() => {
    setOpen(!toBoolean(localStorage.getItem("admin")))
  }, [localStorage.getItem("admin")])

  //

    const [activeButton,setActiveButton] = useState({
      home:true,
      addCategory:false,
      addSubCategory:false,
      addProduct:false,
      listCategory:false,
      listSubcategory:false,
      orderCategory:false,
      orderProduct:false,
    });

    const handleActiveButtonState = ({
      home=false,
      addCategory=false,
      addSubCategory=false,
      addProduct=false,
      listCategory=false,
      listSubcategory=false,
    }) => {
      setActiveButton({
        home:home,
        addCategory:addCategory,
        addSubCategory:addSubCategory,
        addProduct:addProduct,
        listCategory:listCategory,
        listSubcategory:listSubcategory,
      })
    }
    
  return (
    <main>
      <section className="menu section">
        <div className="title">
          <img
            src="./images/brand.png"
            alt="eylul-brand-photo"
            style={{ ml: 5 }}
            width={100}
          />
          <div className="underline" />
        </div>
        <div className="btn-container">
          <Link to="/admin-panel" onClick={()=>handleActiveButtonState({home:true})} className={`filter-btn ${activeButton.home && 'active'}`}>Home</Link>
          <Link to="/admin-panel/add/category" onClick={()=>handleActiveButtonState({addCategory:true})} className={`filter-btn ${activeButton.addCategory && 'active'}`}>Kategori Ekle</Link>
          <Link to="/admin-panel/add/subcategory" onClick={()=>handleActiveButtonState({addSubCategory:true})} className={`filter-btn ${activeButton.addSubCategory && 'active'}`}>Alt Kategori Ekle</Link>
          <Link to="/admin-panel/add/product" onClick={()=>handleActiveButtonState({addProduct:true})} className={`filter-btn ${activeButton.addProduct && 'active'}`}>Ürün Ekle</Link>
          <Link to="/admin-panel/list/category" onClick={()=>handleActiveButtonState({listCategory:true})} className={`filter-btn ${activeButton.listCategory && 'active'}`}>Kategori Düzenle</Link>
          <Link to="/admin-panel/list/subcategory" onClick={()=>handleActiveButtonState({listSubcategory:true})} className={`filter-btn ${activeButton.listSubcategory && 'active'}`}>Alt Kategori Düzenle</Link>
          <Link to="/admin-panel/order/category" onClick={()=>handleActiveButtonState({orderCategory:true})} className={`filter-btn ${activeButton.orderCategory && 'active'}`}>Kategori Sırala</Link>
          <Link to="/admin-panel/order/product" onClick={()=>handleActiveButtonState({orderProduct:true})} className={`filter-btn ${activeButton.orderProduct && 'active'}`}>Ürün Sırala</Link>
          {/* <Link to="/admin-panel/add/category" className={`filter-btn ${(operation === ADD && entity === CATEGORY) ? 'active' : ''}`}>Kategori Ekle</Link>
          <Link to="/admin-panel/add/subcategory" className={`filter-btn ${(operation === ADD && entity === SUBCATEGORY) ? 'active' : ''}`}>Alt Kategori Ekle</Link>
          <Link to="/admin-panel/add/product" className={`filter-btn ${operation===ADD && entity === PRODUCT ? 'active' : ''}`}>Ürün Ekle</Link>
          <Link to="/admin-panel/list/category" className={`filter-btn ${operation===UPDATE && entity === PRODUCT ? 'active' : ''}`}>Kategori Düzenle</Link>
          <Link to="/admin-panel/list/subcategory" className={`filter-btn ${operation===UPDATE && entity === PRODUCT ? 'active' : ''}`}>Alt Kategori Düzenle</Link> */}
        </div>
        {/* <Menu items={menuItems} /> */}
        <Outlet />
        <Dialog open={open}>
        <DialogTitle align="center">Admin Bilgileri</DialogTitle>
        <DialogContent>
            <TextInput
                name="userName"
                value={formik.values.userName}
                onChange={formik.handleChange}
                label="Kullanıcı Adı"
            />
            <TextInput
                name="password"
                value={formik.values.password}
                onChange={formik.handleChange}
                label="Şifre"
            />
        </DialogContent>
        <DialogActions sx={{ display: "flex", justifyContent: "center", mb: 2 }}>
            <SubmitButton label="Giriş Yap" onClick={formik.handleSubmit} />
        </DialogActions>
      </Dialog>
      </section>
    </main>
  );
}

export default AdminPanelLayout;
